import { Component, Input, OnInit, Output, EventEmitter, Injector, ChangeDetectorRef } from '@angular/core';
import { openingHourI } from 'app/core/interfaces/schedule';
import { Location } from 'app/core/interfaces/location';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import * as moment from 'moment';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import Organization from 'app/core/models/Organization';
import { HttpErrorResponse } from '@angular/common/http';
import { hasOverlappingOperationHours } from 'app/core/utils/hoursOfOperation-utils';

@Component({
  selector: 'opening-hours',
  templateUrl: './opening-hours.component.html',
  styleUrls: ['./opening-hours.component.scss'],
})
export class OpeningHoursComponent extends BaseComponent implements OnInit {
  public hours: openingHourI[] = [];
  @Output() onUpdate = new EventEmitter<openingHourI[]>();

  @Output() onUpdateLocation = new EventEmitter<Location>

  public organization: Organization = <Organization>{};
  @Input() location: any = {};

  @Input() mode = '';

  // Para mapear dia da semana para nome (deve ser igual ao usado em hasOverlappingOperationHours)
  private readonly dayNames: { [key: number]: string } = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sábado',
  };

  constructor(private injector: Injector, private organizationLocationService: OrganizationLocationService, private cdr: ChangeDetectorRef) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.mode === 'UPDATE') {
      this.getOrganizationLocationService();
    } else {
      this.hours = this.generateDefaultOperationHours();
    }

    console.log("location hours", location)

    this.cdr.detectChanges();
  }

  public getOrganizationLocationService() {
    const organization_id = this.getUserLogged().id;

    this.organizationLocationService.showByOrganization(organization_id).subscribe({
      next: (location: Location) => {
        this.location = location;

        if (!this.location.hoursOfOperation) {
          this.showWarningMessage = true;
          this.messageWarning = "A visibilidade da organização no sistema depende do preenchimento do horário de atendimento";
        }

        this.hours = this.location.hoursOfOperation && this.location.hoursOfOperation.length > 0 ? this.location.hoursOfOperation : this.generateDefaultOperationHours();
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 404) {
          this.showWarningMessage = true;
          this.messageWarning = "Necessário cadastrar a Localização antes de definir um horário de atendimento";
          return;
        }
      },
    });
  }

  onChangeForm() {
    this.onUpdate.emit(this.hours);
    console.log("alterada")
    this.validateForm();
  }

  generateDefaultOperationHours() {
    const hours = [];
    for (let i = 1; i < 6; i++) {
      hours.push({
        dayOfWeek: i,
        timeStart: '07:00',
        timeEnd: '12:00'
      });

      hours.push({
        dayOfWeek: i,
        timeStart: '14:00',
        timeEnd: '18:00'
      });
    }

    hours.push({
      dayOfWeek: 0,
      timeStart: '',
      timeEnd: ''
    });

    hours.push({
      dayOfWeek: 6,
      timeStart: '',
      timeEnd: ''
    });

    return hours;
  }

  getHoursForDay(day: number): openingHourI[] {
    return this.hours.filter((h) => h.dayOfWeek === day);
  }

  hasRightTime(horario: openingHourI): boolean {
    if (!horario || horario.timeStart === '' || horario.timeEnd === '') {
      return true; // considera válido vazio para evitar erro prematuro
    }
    return moment(horario.timeStart, 'HH:mm').isBefore(moment(horario.timeEnd, 'HH:mm'));
  }

  getDayOfWeekName(code: number): string {
    return this.layout.getDayOfWeekName(code);
  }

  public hasOverlapOnDay(day: number): boolean {
    const overlappingMessages = hasOverlappingOperationHours(this.hours);
    return overlappingMessages.some(msg => msg.includes(this.dayNames[day]));
  }

  public getOverlappingDays(): string[] {
    return hasOverlappingOperationHours(this.hours);
  }

  public validateForm(): boolean {
    this.showErrorMessage = false;
  
    this.messageError = '';
  
    const invalidHours = this.hours.filter(h => !h.timeStart || !h.timeEnd);
    if (invalidHours.length > 0) {
      this.showErrorMessage = true;
      this.messageError = "Existem horários incompletos. Preencha o horário de início e fim corretamente.";
      this.showSuccessMessage = false;
      this.messageSuccess = '';
      return false;
    }

    for (const hour of this.hours) {
      if (!this.hasRightTime(hour)) {
        this.showErrorMessage = true;
        this.messageError = "Existem dias com horário de início posterior ao horário de término";
        this.showSuccessMessage = false;
        this.messageSuccess = '';
        return false;
      }
    }

    const overlappingDays = this.getOverlappingDays();
    if (overlappingDays.length > 0) {
      this.showErrorMessage = true;
      this.messageError = `Conflitos em: ${overlappingDays.join(', ')}`;
      this.showSuccessMessage = false;
      this.messageSuccess = '';
      return false;
    }

    return true;
  }

  salvar() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    this.loading = true;

    if (!this.validateForm()) {
      this.loading = false;
      return;
    }

    const validHours = this.hours.filter(h => h.timeStart && h.timeEnd);
    this.location.hoursOfOperation = validHours;

    this.organizationLocationService.createNew(this.location).subscribe({
      next: (location: any) => {
        this.loading = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.messageSuccess = "Horário salvo com sucesso!";

        this.onUpdateLocation.emit(location)
      },
      error: (err) => {
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.messageError = "Erro ao salvar a localização. Tente novamente mais tarde.";
        this.loading = false;
      },
    });
  }

  addDayOfWeekTime(dayOfWeek: number) {
    this.hours.push({
      dayOfWeek: dayOfWeek,
      timeStart: '',
      timeEnd: '',
    });
    this.onChangeForm();
  }

  removeTime(index: number, dayOfWeek: number) {
    const horariosDoDia = this.hours.filter((h) => h.dayOfWeek === dayOfWeek);
    if (horariosDoDia.length > 1) {
      const horarioParaRemover = horariosDoDia[index];
      const realIndex = this.hours.findIndex((h) => h === horarioParaRemover);
      if (realIndex !== -1) {
        this.hours.splice(realIndex, 1);
        this.onChangeForm();
      }
    }
  }

  public isObjectFilled(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length > 0;
  }
}
